import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)

    let primeiraDoseFebreAmarela = encontrarDose(vacinasAplicadas, '14', '1')
    let doseFebreAmarela = encontrarDose(vacinasAplicadas, '14', '8')
    let dosesFebreAmarela =
      primeiraDoseFebreAmarela != undefined
        ? primeiraDoseFebreAmarela
        : doseFebreAmarela

    return {
      id: index,
      ...item,
      dosePneumococica: encontrarDose(vacinasAplicadas, '26', '2'),
      doseRotaVirus: encontrarDose(vacinasAplicadas, '45', '2'),
      doseMeningococicaC: encontrarDose(vacinasAplicadas, '41', '2'),
      dosePenta: encontrarDose(vacinasAplicadas, '42', '3'),
      doseVip: encontrarDose(vacinasAplicadas, '22', '3'),
      doseFebreAmarela: dosesFebreAmarela,
      doseHepatiteA: encontrarDose(vacinasAplicadas, '55', '1'),
      doseTripliceViral: encontrarDose(vacinasAplicadas, '24', '1'),
    }
  })
  return data
}

function encontrarDose(vacinasAplicadas, id_imuno, id_dose_imuno) {
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_imuno && el.id_dose_imuno == id_dose_imuno
    )
    return doseAplicada
  }
}

export function encontrarDosePendente(vacinasPendentes) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) =>
        (el.id_im == 26 && el.id_d == 2) ||
        (el.id_im == 45 && el.id_d == 2) ||
        (el.id_im == 41 && el.id_d == 2) ||
        (el.id_im == 42 && el.id_d == 3) ||
        (el.id_im == 22 && el.id_d == 3) ||
        (el.id_im == 14 && el.id_d == 1) ||
        (el.id_im == 55 && el.id_d == 1) ||
        (el.id_im == 24 && el.id_d == 1)
    )
    return dosePendente != undefined ? true : false
  }
  return false
}

export function exibirVermelhos(cadastros) {
  const filtro = cadastros.filter((item) => {
    if (item.cfcp == null) {
      return true
    }
    if (item.vacinas_pendentes != null) {
      const temVacinaPendente = encontrarDosePendente(
        JSON.parse(item.vacinas_pendentes)
      )
      if (temVacinaPendente) {
        return true
      }
    } else {
      return false
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  const filtro = cadastros.filter((item) => {
    if (item.vacinas_pendentes == null) {
      return true
    }
  })
  return filtro
}

export function handleFilter(data, filter) {
  let filtrado = data.filter((item) => {
    if (filter === null) {
      return item
    }
    if (filter === '4 meses') {
      return Number(item.idade_meses) == 4
    } else if (filter === '5 meses') {
      return Number(item.idade_meses) == 5
    } else if (filter === '6 meses') {
      return Number(item.idade_meses) == 6
    } else if (filter === '9 meses') {
      return Number(item.idade_meses) == 9
    } else if (filter === '12 meses') {
      return Number(item.idade_meses) == 12
    } else if (filter === '15 meses') {
      return Number(item.idade_meses) == 15
    } else {
      return item
    }
  })
  return filtrado
}

export function generatePdf(cadastros, selectEquipe, nomeProfissional) {
  let cadastrosPdf = formatarCadastrosComDoses(cadastros)
  let title_pdf = 'Dose Imunizante'
  let titlePdfSave = utils.methods.titlePdf(
    'Dose Imunizante',
    selectEquipe.no_equipe
  )

  let description_pdf =
    'Vacinas e doses preconizadas nos indicadores do PNI    '
  let headers_pdf = [
    'DADOS',
    {
      content: 'DOSES',
      // colSpan: 1,
    },
  ]
  var data_pdf = []
  for (let i = 0; i < cadastrosPdf.length; i++) {
    let template = ''
    let obj = {}
    template = `${
      cadastrosPdf[i].nu_cpf !== null && cadastrosPdf[i].nu_cpf !== undefined
        ? 'CPF:' + cadastrosPdf[i].nu_cpf + '\n'
        : ''
    }${
      cadastrosPdf[i].nu_cns !== null && cadastrosPdf[i].nu_cns !== undefined
        ? 'CNS:' + cadastrosPdf[i].nu_cns + '\n'
        : ''
    }Nome: ${
      cadastrosPdf[i].no_cidadao
    }\nNascimento: ${utils.methods.formatDate(
      cadastrosPdf[i].dt_nascimento
    )}\nMeses: ${cadastrosPdf[i].idade_meses} \nMãe: ${
      cadastrosPdf[i].no_mae
    } \nMA: ${cadastrosPdf[i].micro_area ?? ''}`
    obj.dados = template
    obj.doses = cadastrosPdf[i]
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        columnStyles: {
          0: {
            cellWidth: 45,
          },
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 8,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        didDrawCell: function (data) {
          if (data.column.dataKey === 1 && data.cell.section == 'body') {
            let doses = data.row.raw[1]

            const dosePneumococica =
              doses.dosePneumococica != undefined
                ? `${doses.dosePneumococica.dt_aplicacao_br} \ncom ${doses.dosePneumococica.meses} meses`
                : ''

            const doseRotaVirus =
              doses.doseRotaVirus != undefined
                ? `${doses.doseRotaVirus.dt_aplicacao_br}  \ncom ${doses.doseRotaVirus.meses} meses`
                : ''

            const doseMeningococicaC =
              doses.doseMeningococicaC != undefined
                ? `${doses.doseMeningococicaC.dt_aplicacao_br}  \ncom ${doses.doseMeningococicaC.meses} meses`
                : ''

            const dosePenta =
              doses.dosePenta != undefined
                ? `${doses.dosePenta.dt_aplicacao_br}  \ncom ${doses.dosePenta.meses} meses`
                : ''

            const doseVip =
              doses.doseVip != undefined
                ? `${doses.doseVip.dt_aplicacao_br}  \ncom ${doses.doseVip.meses} meses`
                : ''

            const doseFebreAmarela =
              doses.doseFebreAmarela != undefined
                ? `${doses.doseFebreAmarela.dt_aplicacao_br}  \ncom ${doses.doseFebreAmarela.meses} meses`
                : ''

            const doseTripliceViral =
              doses.doseTripliceViral != undefined
                ? `${doses.doseTripliceViral.dt_aplicacao_br}  \ncom ${doses.doseTripliceViral.meses} meses`
                : ''

            const doseHepatiteA =
              doses.doseHepatiteA != undefined
                ? `${doses.doseHepatiteA.dt_aplicacao_br}  \ncom ${doses.doseHepatiteA.meses} meses`
                : ''

            doc.autoTable({
              head: [
                [
                  `PNEUMO 10V\n(D2)\n4 meses`,
                  `ROTA VÍRUS\n(D2)\n4 meses`,
                  `MENINGO C\n(D2)\n meses`,
                  `PENTA\n (D3)\n6 meses`,
                  `VIP\n (D3)\n6 meses`,
                  `F. AMARELA\n (D1)\n9 meses`,
                  `T. VIRAL\n (D1)\n12 meses`,
                  `HEPATITE A\n (D1)\n15 meses`,
                ],
              ],
              body: [
                [
                  dosePneumococica,
                  doseRotaVirus,
                  doseMeningococicaC,
                  dosePenta,
                  doseVip,
                  doseFebreAmarela,
                  doseTripliceViral,
                  doseHepatiteA,
                ],
              ],
              headStyles: {
                fillColor: '#ccc',
                fontSize: 6,
                textColor: '#000',
                halign: 'center',
                cellWidth: 'wrap',
              },
              startY: data.cell.y + 2,
              margin: {
                left: data.cell.x,
              },
              tableWidth: 'wrap',
              theme: 'grid',
              styles: {
                fontSize: 7,
                cellPadding: 1,
              },
            })
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
